import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, UntypedFormGroup, Validators} from '@angular/forms';
import { AuthenticationService } from "../services/authentication.service";
import { Router } from "@angular/router";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    standalone: false
})
export class RegisterComponent implements OnInit {
  credentialForm = new UntypedFormGroup({});
  accountErrorMessage: string | undefined;
  formSubmitted = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private router: Router
  ) {
    this.authService.redirectLoggedInUser();
  }

  ngOnInit(): void {
    this.credentialForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  async signUp() {
    this.formSubmitted = true;
    if(!this.credentialForm.valid) {
      return;
    }

    this.authService
      .signUp(this.credentialForm.value)
      .then(
        () => {
          this.router.navigateByUrl('/activiteiten', { replaceUrl: true });
        },
        async (error) => {
          switch (error.code) {
            case "auth/email-already-in-use": {
              this.accountErrorMessage = "Dit emailadres is al in gebruik door een ander account. Probeer een ander emailadres.";
              break;
            }
            default: {
              this.accountErrorMessage = "Onverwachte error. Probeer het later opnieuw.";
              break;
            }
          }
        }
      );
  }

  get firstname() {
    return this.credentialForm.get('firstName');
  }

  get email() {
    return this.credentialForm.get('email');
  }

  get password() {
    return this.credentialForm.get('password');
  }
}
